import { useCallback, useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import getDataset from 'api/Dataset/getDataset';
import { Dataset, datasetDefault } from 'types/Dataset';
import getDatasetStack from 'api/Stack/getDatasetStack';

export default function useDataset() {
    const client = useClient();
    const { openAlert } = useAlert();
    const params = useParams<{ uri: string }>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [dataset, setDataset] = useState<Dataset>(datasetDefault);
    const [isUserAdmin, setIsUserAdmin] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            if (params.uri) {
                const response = await client?.query(getDataset(params.uri));
                if (!response.errors) {
                    setDataset({
                        ...response.data.getDataset,
                    });
                    const role = response.data.getDataset.userRoleForDataset;
                    setIsUserAdmin(
                        role !== 'NoPermission' && role !== 'Shared',
                    );
                } else {
                    setError(true);
                    openAlert({
                        message:
                            'Something went wrong... Could not retrieve dataset',
                        severity: 'alert',
                    });
                }
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    const getStackStatus = useCallback(async () => {
        if (client && params.uri) {
            const response = await client?.query(getDatasetStack(params.uri));
            return response.data.getDataset.stack.status;
        }
    }, [client, params.uri]);

    return {
        dataset,
        isUserAdmin,
        error,
        getStackStatus,
        loading,
        fetchData,
    };
}
